import { useTranslation } from "react-i18next";

export default function DeliveryMethod ( { data } ) { 

    const { t } = useTranslation ();

    const courierCalled = !!data?.courierPickupId;

    return (

        <td data-title={ t ( "deliveryMethod" ) }>

            <div>
                { t ( data?.deliveryMethod ) }
                { courierCalled && (
                    <span
                        className="badge bg-info ms-1"
                        title={ t ( "courier_called" ) }
                    >
                        { t ( "courier_called" ) }
                    </span>
                ) }
            </div>

        </td>

    );

};